import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Modal  } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';
import deleteimg from '../../assets/images/icon/delete.png';


const { Panel } = Collapse;
const { Search } = Input;
const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			school_list: [],
			
			loading: false,
			visible: false,
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id}
			getData('erp/cctv_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
						});
					}else{
						this.setState({
							school_list: [],
							
						});
					}
				}
			});
	}
  }
	
	hide = () => {
    this.setState({
      visible: false,
    });
  };
  
  handleVisibleChange = visible => {
    this.setState({ visible });
  };
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false, visible: false });
    }, 3000);
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };
  
  handledelete= (id) => {
   
	if(localStorage.getItem('schoolData')){
    this.setState({ loading: true });
	var storedArray = JSON.parse(localStorage.getItem("schoolData"));
    var user_id = storedArray['data'][0]['user_id'];
			
			var app = {user_id : user_id,id:id}
      getData('erp/cctv_delete',app).then((result) => {
      if(result.status==400){
            alert(result.message);
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Tags Delete',2);
             
             // window.location.href = '/tags/index/';
            this.checkData();

          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }

	render()

	{
	
	const { size } = this.state;
	  const { visible, loading } = this.state;			
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		  <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="container">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40">
                     
					  <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">CCTV Access</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">CCTV Access
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
	
          
		  <div class="col s12 m12 ex-padd">  
            <div class="container view-Profile viewprograms view-Profile-mobile">
			   <div class="col s12 m12 mb-20  mh-500 no-padd">
                  <section class=" section food no-padd">
					
					<div class="children bg-blue communication iq-card2 flow-root mb-20 pt-20 pb-20">
                     
							<div class="children bg-blue attendance">
								{this.state.school_list.map((list) => (
								<div class="col m6 mb-10 pt-10 center">
									<div class="shadow">
									<div class="col m9 s9 no-padd">
										<div class="col m12 s12 t-left mt-10">
											<label>Link </label> : <span>{list.short_url}</span>
										</div>
										<div class="col m12 s12 t-left mt-10">
											<label>Name </label> : <span>{list.name}</span>
										</div>
									</div>
									<div class="col m3 s3 pt-10 pr-0 pl-0">
										<Link to={`${process.env.PUBLIC_URL}/cctv/edit-cctv/${list.id}`}><img src={edit} class="cctv-img"/></Link>
										
										<img src={deleteimg} class="cctv-img" onClick={this.handledelete.bind(this,list.id)} />
									</div>
									</div>
								</div>
								))}
								
								<div class="col m12 mt-10 mb-20 center"><Link to={`${process.env.PUBLIC_URL}/cctv/add-cctv`}><Button className="snd-btn"  >Add</Button></Link></div> 
							</div>	
							
					
					</div>

								
					
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
